import React, { ReactNode } from "react";
import {
  AppBar,
  Box,
  CssBaseline,
  Toolbar,
  Typography,
} from "@mui/material";
import Sidebar from "./Sidebar";

interface DashboardProps {
  children: ReactNode;
}

const Dashboard: React.FC<DashboardProps> = ({ children }) => {
  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <CssBaseline />

      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          boxShadow: "none",
          borderRadius: 0,
        }}
      >
        <Toolbar sx={{ minHeight: 64, px: 3 }}>
          <Typography variant="h6" fontWeight={600}>
            Multi-domain CMS
          </Typography>
        </Toolbar>
      </AppBar>

      <Sidebar />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: "64px", 
          height: "calc(100vh - 64px)", 
          overflowY: "auto",
          overflowX: "hidden",
          px: 4,
          py: 3,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Dashboard;
